import Phaser from 'phaser';
import { saveManager } from './SaveManager';
import { audio } from './AudioSynth';
import { music } from './MusicSystem';
import { localMusic } from './LocalMusicPlayer';

/** Push the persisted audio settings into the synth engines. */
export function applyAudioSettings(): void {
  const s = saveManager.data.settings;
  audio.enabled = s.sfx;
  audio.volume = s.sfxVolume;
  // Procedural MIDI + authored cues share the music toggle.
  music.applyEnabled(!!s.music, s.music ? s.musicVolume : 0);
  // Commander tracks honour the same master music switch so a refresh with
  // music OFF cannot resume a local playlist.
  localMusic.setVolume(s.music ? s.musicVolume : 0);
  if (!s.music) localMusic.stop();
}

/** Apply the persisted display mode (FIT = whole field visible, FILL = cover). */
export function applyScaleMode(game: Phaser.Game): void {
  const s = saveManager.data.settings;
  const mode = s.scaleMode === 'fill' ? Phaser.Scale.ENVELOP : Phaser.Scale.FIT;
  if (game.scale.scaleMode !== mode) {
    game.scale.scaleMode = mode;
    game.scale.refresh();
  }
}
